(function(){
  var cfg = window.NOQRO || {};
  var $ = function(s, r){ return (r || document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents){
    var v = (cents / 100);
    var s = v % 1 === 0 ? v.toLocaleString('he-IL') : v.toLocaleString('he-IL', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    return '₪' + s;
  }
  function esc(t){ var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }

  /* header shadow on scroll */
  var hdr = $('.hdr');
  if (hdr) { var onS = function(){ hdr.classList.toggle('scrolled', window.scrollY > 10); }; window.addEventListener('scroll', onS, {passive: true}); onS(); }

  /* showcase color switcher */
  $$('[data-show]').forEach(function(sec){
    var imgs = $$('.stage img', sec), btns = $$('[data-show-i]', sec), name = $('[data-show-name]', sec), link = $('[data-show-link]', sec);
    var cur = 0, timer = null, visible = false, hold = false;
    var ms = +sec.getAttribute('data-show-auto') || 0;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(i){
      var b = btns[i]; if (!b) return; cur = i;
      imgs.forEach(function(im, k){ im.classList.toggle('on', k === i); });
      btns.forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (name) name.textContent = b.getAttribute('aria-label');
      if (link && b.getAttribute('data-href')) link.href = b.getAttribute('data-href');
    }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }
    function start(){ stop(); if (!ms || reduce || !visible || hold || btns.length < 2) return; timer = setInterval(function(){ go((cur + 1) % btns.length); }, ms); }
    btns.forEach(function(b){ b.addEventListener('click', function(){ go(+b.getAttribute('data-show-i')); start(); }); });
    sec.addEventListener('focusin', function(e){ if (e.target.matches(':focus-visible')) { hold = true; stop(); } });
    sec.addEventListener('focusout', function(){ hold = false; start(); });
    document.addEventListener('visibilitychange', function(){ if (document.hidden) stop(); else start(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function(en){ visible = en[0].isIntersecting; if (visible) start(); else stop(); }, {threshold: .3}).observe(sec);
    else { visible = true; start(); }
    imgs.forEach(function(im){ im.loading = 'eager'; });
  });

  /* mobile menu */
  var mt = $('[data-menu-toggle]'), mn = $('#mobile-nav');
  if (mt && mn) mt.addEventListener('click', function(){
    var open = mn.hasAttribute('hidden');
    if (open) mn.removeAttribute('hidden'); else mn.setAttribute('hidden', '');
    mt.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* product filters */
  $$('[data-filters]').forEach(function(group){
    var scope = group.closest('section');
    $$('button', group).forEach(function(b){
      b.addEventListener('click', function(){
        $$('button', group).forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var f = b.getAttribute('data-filter');
        $$('[data-tags]', scope).forEach(function(c){
          var tags = (c.getAttribute('data-tags') || '').split(',');
          if (f === 'all' || tags.indexOf(f) > -1) c.removeAttribute('hidden'); else c.setAttribute('hidden', '');
        });
      });
    });
  });

  /* cart drawer */
  var drawer = $('#cart-drawer'), shade = $('#cart-shade'), lastFocus = null;
  function openCart(){
    if (!drawer) { window.location.href = cfg.cartUrl || '/cart'; return; }
    lastFocus = document.activeElement;
    drawer.removeAttribute('hidden'); shade.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    var c = $('[data-cart-close]', drawer); if (c) c.focus();
  }
  function closeCart(){
    if (!drawer) return;
    drawer.setAttribute('hidden', ''); shade.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  $$('[data-cart-open]').forEach(function(b){ b.addEventListener('click', function(e){ if (drawer) { e.preventDefault(); refresh().then(openCart); } }); });
  $$('[data-cart-close]').forEach(function(b){ b.addEventListener('click', closeCart); });
  if (shade) shade.addEventListener('click', closeCart);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer && !drawer.hasAttribute('hidden')) closeCart(); });

  function setBadge(n, pop){
    $$('[data-cart-count]').forEach(function(b){
      b.textContent = n;
      if (n > 0) b.removeAttribute('hidden'); else b.setAttribute('hidden', '');
      if (pop) { b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); }
    });
    var lbl = $('[data-cart-title]'); if (lbl) lbl.textContent = (cfg.t && cfg.t.cartTitle || 'הסל שלך') + ' (' + n + ')';
  }

  function render(cart){
    if (!drawer) return;
    var items = $('[data-cart-items]', drawer);
    var th = cfg.freeShip || 0;
    var ship = $('[data-ship]', drawer);
    if (ship) {
      if (th > 0) {
        var left = th - cart.total_price;
        $('b', ship).textContent = left > 0 ? ('עוד ' + money(left) + ' למשלוח חינם') : 'יש לכם משלוח חינם!';
        $('i', ship).style.width = Math.min(100, Math.round(cart.total_price / th * 100)) + '%';
        ship.removeAttribute('hidden');
      } else ship.setAttribute('hidden', '');
    }
    if (!cart.item_count) {
      items.innerHTML = '<div class="empty">הסל ריק כרגע.<br><a href="' + (cfg.allUrl || '/collections/all') + '">לכל המוצרים</a></div>';
    } else {
      items.innerHTML = cart.items.map(function(it, i){
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
        return '<div class="line">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '<div class="t"><b>' + esc(it.product_title) + '</b>' + variant + '<small>' + money(it.final_line_price) + '</small>' +
          '<div class="q"><button type="button" data-q="' + (i + 1) + '" data-v="' + (it.quantity - 1) + '" aria-label="הפחתת כמות">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-q="' + (i + 1) + '" data-v="' + (it.quantity + 1) + '" aria-label="הוספת כמות">+</button></div></div>' +
          '<button type="button" class="rm" data-q="' + (i + 1) + '" data-v="0" aria-label="הסרת ' + esc(it.product_title) + '">הסרה</button></div>';
      }).join('');
    }
    var tot = $('[data-cart-total]', drawer); if (tot) tot.textContent = money(cart.total_price);
    var foot = $('.foot', drawer); if (foot) foot.style.display = cart.item_count ? '' : 'none';
    setBadge(cart.item_count);
  }

  function refresh(){ return fetch((cfg.root || '/') + 'cart.js', {headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); }).then(function(c){ render(c); return c; }); }

  if (drawer) drawer.addEventListener('click', function(e){
    var b = e.target.closest('[data-q]'); if (!b) return;
    b.disabled = true;
    fetch((cfg.root || '/') + 'cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({line: +b.getAttribute('data-q'), quantity: Math.max(0, +b.getAttribute('data-v'))})})
      .then(function(r){ return r.json(); }).then(render).catch(function(){ b.disabled = false; });
  });

  /* ajax add to cart for every product form */
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (!f.matches || !f.matches('form[action$="/cart/add"]') || !drawer) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]'), orig = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'מוסיף…'; }
    fetch((cfg.root || '/') + 'cart/add.js', {method: 'POST', headers: {'Accept': 'application/json'}, body: new FormData(f)})
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(){ return refresh(); })
      .then(function(c){ setBadge(c.item_count, true); openCart(); })
      .catch(function(err){ alertMsg(f, (err && (err.description || err.message)) || 'לא הצלחנו להוסיף לסל. נסו שוב.'); })
      .then(function(){ if (btn) { btn.disabled = false; btn.innerHTML = orig; } });
  });
  function alertMsg(f, m){
    var el = f.querySelector('[data-form-error]');
    if (!el) { el = document.createElement('p'); el.setAttribute('data-form-error', ''); el.setAttribute('role', 'alert'); el.className = 'errors'; el.style.marginTop = '12px'; f.appendChild(el); }
    el.textContent = m;
  }

  /* product page */
  $$('[data-product]').forEach(function(root){
    var dataEl = $('script[data-product-json]', root);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = $('form[action$="/cart/add"]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var mainImg = $('[data-main-img]', root);
    var thumbs = $$('[data-thumb]', root);
    var selected = (product.selected || []).slice();

    function showMedia(src, alt, idx){
      if (!mainImg || !src) return;
      mainImg.style.animation = 'none'; void mainImg.offsetWidth; mainImg.style.animation = '';
      mainImg.src = src; mainImg.removeAttribute('srcset'); if (alt) mainImg.alt = alt;
      thumbs.forEach(function(t){ t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(idx) ? 'true' : 'false'); });
      var cap = $('[data-caption]', root); var th = thumbs.filter(function(t){ return t.getAttribute('data-thumb') === String(idx); })[0];
      if (cap && th) cap.textContent = th.getAttribute('data-cap') || cap.textContent;
    }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ showMedia(t.getAttribute('data-src'), t.getAttribute('data-alt'), t.getAttribute('data-thumb')); }); });
    /* gallery arrows + swipe */
    var galMain = mainImg ? mainImg.closest('.main') : null, galCount = $('[data-gal-count]', root);
    function curIdx(){ for (var k=0;k<thumbs.length;k++){ if (thumbs[k].getAttribute('aria-current')==='true') return k; } return 0; }
    function galGo(step){
      if (!thumbs.length) return;
      var n = (curIdx() + step + thumbs.length) % thumbs.length, t = thumbs[n];
      showMedia(t.getAttribute('data-src'), t.getAttribute('data-alt'), t.getAttribute('data-thumb'));
    }
    function updCount(){ if (galCount && thumbs.length) galCount.textContent = (curIdx()+1) + ' / ' + thumbs.length; }
    $$('[data-gal-step]', root).forEach(function(b){ b.addEventListener('click', function(){ galGo(parseInt(b.getAttribute('data-gal-step'),10)); updCount(); }); });
    thumbs.forEach(function(t){ t.addEventListener('click', updCount); });
    if (galMain && thumbs.length > 1) {
      var sx = null, sy = null;
      galMain.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, {passive:true});
      galMain.addEventListener('touchend', function(e){
        if (sx === null) return; var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { galGo(dx < 0 ? 1 : -1); updCount(); }
      });
      galMain.setAttribute('tabindex','0');
      galMain.addEventListener('keydown', function(e){ if (e.key==='ArrowLeft'){ galGo(1); updCount(); } else if (e.key==='ArrowRight'){ galGo(-1); updCount(); } });
    }

    $$('[data-opt]', root).forEach(function(b){
      b.addEventListener('click', function(){
        var pos = +b.getAttribute('data-opt');
        selected[pos] = b.getAttribute('data-val');
        $$('[data-opt="' + pos + '"]', root).forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var lab = $('[data-opt-label="' + pos + '"]', root); if (lab) lab.textContent = selected[pos];
        var v = product.variants.filter(function(v){ return v.options.every(function(o, i){ return o === selected[i]; }); })[0];
        update(v);
      });
    });

    function update(v){
      var add = form ? $('[type="submit"]', form) : null;
      if (!v) { if (add) { add.disabled = true; add.textContent = 'לא זמין'; } return; }
      if (idInput) idInput.value = v.id;
      $$('[data-price-now]', root.ownerDocument).forEach(function(p){ p.textContent = money(v.price); });
      $$('[data-price-was]', root.ownerDocument).forEach(function(p){
        if (v.compare_at_price && v.compare_at_price > v.price) { p.textContent = money(v.compare_at_price); p.removeAttribute('hidden'); } else p.setAttribute('hidden', '');
      });
      if (add) { add.disabled = !v.available; add.textContent = v.available ? 'הוספה לסל' : 'אזל מהמלאי'; }
      $$('[data-sticky-variant]').forEach(function(s){ s.textContent = v.title === 'Default Title' ? '' : ' · ' + v.title; });
      if (v.featured_media) {
        var th = thumbs.filter(function(t){ return t.getAttribute('data-media-id') === String(v.featured_media.id); })[0];
        if (th) showMedia(th.getAttribute('data-src'), th.getAttribute('data-alt'), th.getAttribute('data-thumb'));
        $$('[data-sticky-img]').forEach(function(i){ i.src = th ? th.getAttribute('data-src') : i.src; });
      }
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
    }

    var q = $('[data-qty]', root);
    if (q) {
      var inp = $('input', q);
      $$('button', q).forEach(function(b){ b.addEventListener('click', function(){ inp.value = Math.max(1, Math.min(99, (+inp.value || 1) + (+b.getAttribute('data-step')))); }); });
    }

    var sticky = $('[data-sticky]'), anchor = form;
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(en){ var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sticky.classList.toggle('on', past); document.body.classList.toggle('sticky-on', past); sticky.setAttribute('aria-hidden', past ? 'false' : 'true'); }).observe(anchor);
      var sb = $('[data-sticky-add]', sticky);
      if (sb) sb.addEventListener('click', function(){ if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }
  });

  refresh().catch(function(){});
})();
